import React from "react";
import { FormRenderer } from "./form-renderer";
import { cn } from "../../../lib/utils";

const FormContainer = ({
  sectionTitle = "Address Information",
  subtitle = null,
  headerTitle,
  readOnly,
  fields,
  values,
  onFieldChange,
  onFieldBlur,
  fieldValues,
  currentPiiInfoFields,
  handleFieldLevelHandler,
  componentContext = {},
  customClasses = {},
  children,
  actionButtons = null,
}) => {
  const supplementAddressData = {
    city: values?.city,
    state: values?.state,
    zipCode: values?.zipCode,
    countyName: values?.countyName,
  };
  return (
    <div
      className={`
        rounded-3xl border border-gray-200 bg-white
        ${customClasses?.formContainer || ""}
      `}
    >
      {sectionTitle && (
        <div
          className={cn(
            "bg-[#E8E2D8] px-6 py-4 border-b border-gray-200 rounded-t-3xl",
            actionButtons ? "flex items-center justify-between" : "",
            customClasses?.formHeader || ""
          )}
        >
          <div>
            <div
              className={`
                text-lg font-semibold text-gray-800 
                ${customClasses?.formTitle || ""}
              `}
            >
              {sectionTitle}
            </div>
            {subtitle && (
              <div
                className={`
                  text-sm text-gray-600 mt-1
                  ${customClasses?.formSubtitle || ""}
                `}
              >
                {subtitle}
              </div>
            )}
          </div>
          {actionButtons && <>{actionButtons}</>}
        </div>
      )}
      <div className={`p-4 ${customClasses?.formBody || ""}`}>
        {children ? (
          // Render children if they exist
          children
        ) : (
          // Otherwise render the existing form fields
          <>
            {headerTitle && (
              <label
                className={`block text-sm font-medium text-gray-700 mb-2 ${
                  customClasses?.formSubHeader || ""
                }`}
              >
                {headerTitle}
              </label>
            )}
            <div className={`-mx-2 flex flex-wrap`}>
              {fields.map((item) => (
                <FormRenderer
                  key={item.uniqueField}
                  item={item}
                  fieldValue={values[item.uniqueField]}
                  onFieldChange={onFieldChange}
                  onFieldBlur={onFieldBlur}
                  fieldValues={fieldValues}
                  readOnly={readOnly}
                  currentPiiInfoFields={currentPiiInfoFields}
                  handleFieldLevelHandler={handleFieldLevelHandler}
                  componentContext={componentContext}
                  supplementAddressData={supplementAddressData}
                  customClasses={customClasses}
                />
              ))}
            </div>
          </>
        )}
      </div>
    </div>
  );
};

export { FormContainer };
